import { render } from "./RecordEdit.vue?vue&type=template&id=1907ec69"
import script from "./RecordEdit.vue?vue&type=script&lang=js"
export * from "./RecordEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__